module.exports = __webpack_public_path__ + "media/summer_2023_sweepstakes/your-future-is-now-confirmation-lock-up2-5aa77e60.png";